// removed by extract-text-webpack-plugin
module.exports = {"ContactData":"-name__-loca-__1J81r"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Checkout/ContactData/ContactData.css
// module id = 189
// module chunks = 0